import React, { Fragment, useState, useEffect } from 'react';
import $ from 'jquery';
import { useSelector, useDispatch } from 'react-redux';
import { useAlert } from 'react-alert';
import MetaData from '../layout/MetaData';
import { IMAGES } from '../../constants';
import { JEWELER_SMALL, JEWELER_SMALL_SEARCHES, NEW_FREE_PLAN_FEATURE, UNLIMITED_SEARCH, JEWELER_SMALL_TEXT, NEW_FREE_DOWNGRADE_FEATURE } from '../../constants/index';
// import { submitPaymentInfo } from '../actions/userActions';
import { flip, savePercentage, movetoNext, setColor, deviceDisplay, hashReqDecodeData, numberWithCommas, hashResEncodeData, PlanType } from '../../helper';
import { Link, useHistory, useLocation } from "react-router-dom";
import { validateFields } from '../../validation';
import classnames from 'classnames';
import { currentPlan, getPlanByRole } from '../../actions/userActions';
import { setFreemium } from '../../actions/userActions';
import { FormattedMessage } from 'react-intl';
import { currency, url, base_url, BASE_URL, SC } from '../../config';
import CurrencyLiraIcon from '@mui/icons-material/CurrencyLira';
import Loader from './../layout/Loader';

import {
    // CardElement,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    // Elements,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import { toast, ToastContainer } from 'react-toastify';
import { PurchasePlanStripeAction } from '../../actions/stripeAction';
import Confirmation from './registrationProcess/Confirmation';
import axios from 'axios';

const NewBillingInformation = ({ rerenderParentCallback }) => {
    const history = useHistory();

    const dispatch = useDispatch()
    const alert = useAlert()
    const location = useLocation()
    const [loaderStripe, setLoaderStripe] = useState(false)
    const { error, paymentInfoData, paymentscript } = useSelector(state => state.paymentData)
    const [user, setUser] = useState(location?.state?.userData ? location?.state?.userData : localStorage.getItem('dummyuserData'));
    const [plan_role, setPlanRole] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentplan, setCurrentPlan] = useState({});
    const authToken = location?.state?.token ? location?.state?.token : localStorage.getItem('dummytoken');
    var head_lang = localStorage?.getItem('lang') ? localStorage.getItem('lang') : 'en';
    var head_country = localStorage?.getItem('country') ? localStorage.getItem('country') : 'turkey';

    const stripe = useStripe();
    const elements = useElements();
    const [selectedPlan, setSelectedPlan] = useState({
        planName: "",
        planPrice: "",
        stripePlanId: ""
    });


    useEffect(() => {
        $('#busi-info-sidebar').addClass('visited')
        $('#bill-info-sidebar').addClass('active')
    })

    useEffect(() => {
        if (location?.state?.token) {
            localStorage.setItem('dummytoken', location?.state?.token)
            localStorage.setItem('dummyuserData', location?.state?.userData)
        }
        var head_lang = localStorage?.getItem('lang') ? localStorage.getItem('lang') : 'en';
        var head_country = localStorage?.getItem('country') ? localStorage.getItem('country') : 'turkey';
        setLoading(true)
        axios.get(`${BASE_URL}/get-plans-for-upgrade`, {
            headers: {
                "Authorization": `Bearer ${authToken}`,
                'lang': head_lang,
                'country': head_country,
                'sc': SC,
                // 'Device-Token': localStorage.getItem('uuid')
            }
        }).then(async (res) => {
            if (res?.data?.status) {
                setLoading(false)
                const decrypted_data = await hashReqDecodeData(res?.data?.data)
                setPlanRole(decrypted_data?.plans?.filter(plan => (plan?.id != user?.plan_id &&  plan?.id != "32" )))
                setCurrentPlan(decrypted_data?.CurrentPlan)
            }
        }).catch((err) => {
            alert.error("Something went wrong, please try again later")
        })
    }, [])

    useEffect(() => {
        if (paymentInfoData) {
            alert.success(paymentInfoData)
            if (paymentscript) {
                var script = document.createElement("script");
                script.innerHTML = paymentscript;
                document.body.appendChild(script);
            } else {
                rerenderParentCallback()
            }
        }
        if (error) {
            alert.error(error)
        }
    }, [error, paymentInfoData, rerenderParentCallback, alert, paymentscript])



    const [paymentInfo, setPaymentInfo] = useState({
        plan_id: "",
        plan_payment_period: 1,
        plan_name: "",
        // card_holder_name: user.name,
        // cvv: "",
        check: false,
        privacyCheck: false,
        ElectronicMsgCheck: false
    })


    const handlePlanPaymentPeriod = (event) => {
        // setPaymentInfo({ ...paymentInfo, plan_id: "" })
        $(".all-plan").removeClass("sub_active")
        // setPaymentInfo(plan_id)
        if (event.target.checked == true) {
            setPaymentInfo({ ...paymentInfo, plan_payment_period: 2, plan_id: "" });
        } else {
            setPaymentInfo({ ...paymentInfo, plan_payment_period: 1, plan_id: "" });
        }
    }

    const selectPlan = (stripePlanId, planName, planPrice, planId) => {
        //reg-plans
        $(".all-plan").removeClass("sub_active")
        $(".pln-box-" + planId).addClass("sub_active")
        setSelectedPlan({
            planName: planName,
            planPrice: planPrice,
            stripePlanId: stripePlanId
        })
        setPaymentInfo({ ...paymentInfo, plan_id: planId, plan_name: planName });
    }

    const handleStripe = async (event) => {
        event.preventDefault();

        if (!paymentInfo.plan_id || paymentInfo.plan_id === "") {
            alert.error("You must choose a plan before proceeding.");
            return;
        }
        if (paymentInfo?.plan_id === "" && paymentInfo.check !== false && paymentInfo.privacyCheck !== false) {
            window.location.href = url;
        }

        if (paymentInfo?.plan_id !== "" && paymentInfo.check == false && paymentInfo.privacyCheck == false) {
            const selectedPlanDetails = plan_role?.find(plan => plan.id === paymentInfo.plan_id);
            if (selectedPlanDetails?.user_type === 0) {
                // Call setFreemium API for user_type 0
                const payload = {
                    check: user.is_guideline_view_tc,
                    privacyCheck: user.is_guideline_view_pp,
                    ElectronicMsgCheck: user.is_guideline_view_em,
                    device_token: localStorage.getItem("uuid"),
                    device_type: "WEB"
                };
                setLoading(true)
                const encodedData = hashResEncodeData(payload);
                axios.post(`${BASE_URL}/set-freemium`, encodedData, {
                    headers: {
                        "Authorization": `Bearer ${authToken}`,
                        'lang': head_lang,
                        'country': head_country,
                        'sc': SC,
                    }
                }).then((res) => {
                    if (res?.data?.status) {
                        setLoading(false)
                    }
                }).catch((err) => {
                    setLoading(false)
                    alert.error(err?.response?.data?.message || "Something went wrong, please try again later")
                })
                // await dispatch(setFreemium(payload));
                alert.success("Freemium plan activated successfully!");
                // window.location.href = url;
                window.location.href = url + "/payment-success";
            } else {
                // Proceed with Stripe payment for other user types
                setLoaderStripe(true);
                const payload = {
                    price_id: selectedPlan.stripePlanId,
                    success_url: url + "/payment-success",
                    // success_url: "/payment-success",
                    cancel_url: location?.pathname,
                    check: user?.is_guideline_view_tc,
                    privacyCheck: user?.is_guideline_view_pp,
                    ElectronicMsgCheck: user?.is_guideline_view_em,
                };
                const encodedData = hashResEncodeData(payload);


                axios.post(`${BASE_URL}/create-subscription`, encodedData, {
                    headers: {
                        "Authorization": `Bearer ${authToken}`,
                        'lang': head_lang,
                        'country': head_country,
                        'sc': SC,
                    }
                }).then(async (res) => {
                    const updateData = await hashReqDecodeData(res?.data?.data)
                    if (res?.data?.status == true) {
                        setLoading(false)
                        setLoaderStripe(false);
                        window.location.href = updateData?.url
                    } else {
                        setLoading(false)
                        setLoaderStripe(false);
                        alert.error(res?.data?.message || "Something went wrong, please try again later")
                    }
                }).catch((err) => {
                    setLoading(false)
                    setLoaderStripe(false);
                    alert.error(err?.response?.data?.message || "Something went wrong, please try again later")
                })

            }
        }
    };

    const stringReplace = (text) => {
        let replace = text.replace(/(<([^>]+)>)/ig, '');
        return replace;
    }

    const handleCancelSubsClick = (event) => {
        // setcancelPopUp(true);
        $("#popup-click-confirm").trigger('click');
    }

    const handleSubmit = async (event) => {
        try {

            await setLoaderStripe(true)

            let payload = await {};
            setLoaderStripe(true)
            payload = {
                price_id: event.stripePlanId,
                success_url: location?.pathname,
                cancel_url: location?.pathname,
                check: user?.is_guideline_view_tc,
                privacyCheck: user?.is_guideline_view_pp,
                ElectronicMsgCheck: user?.is_guideline_view_em,
                is_renew_click: event?.is_renew_click ? event?.is_renew_click : 0
                // success_url: "/plan-details",
                // cancel_url:  "/plan-details"
            };
            const encodedData = hashResEncodeData(payload);


            axios.post(`${BASE_URL}/create-subscription`, encodedData, {
                headers: {
                    "Authorization": `Bearer ${authToken}`,
                    'lang': head_lang,
                    'country': head_country,
                    'sc': SC,
                }
            }).then(async (res) => {
                const updateData = await hashReqDecodeData(res?.data?.data)
                if (res?.data?.status == true) {
                    setLoading(false)
                    setLoaderStripe(false);
                    window.location.href = updateData?.url
                } else {
                    setLoading(false)
                    setLoaderStripe(false);
                    alert.error(res?.data?.message || "Something went wrong, please try again later")
                }
            }).catch((err) => {
                setLoading(false)
                setLoaderStripe(false);
                alert.error(err?.response?.data?.message || "Something went wrong, please try again later")
            })
        } catch (err) {
            console.error(err?.message);
        }
    };
    const handleRenewSubscription = () => {
        const planId = currentplan?.plan_payment_period == 1 ?
            currentplan?.plan_id_month : currentplan?.plan_id_year;
        handleSubmit({ stripePlanId: planId, is_renew_click: 1 })
    }

    return (
        <Fragment>
            {loaderStripe || loading ? <Loader /> : ''}
            <div className="payment-page">
                <div className="container">
                    <MetaData title={`billing information`} />
                    <div className="billing-card">
                        <div className="card_head mt-3">
                            <div className="card_head_left">
                                <h3 className="black-3B font-20 fm">
                                    <FormattedMessage
                                        id="business.welcome"
                                        defaultMessage="Welcome"
                                    />
                                </h3>
                                <h2>{user && user.name}</h2>
                            </div>
                            <p className="text-dark">{user && user.role == 1 ? <FormattedMessage id="register.jeweler" /> : <FormattedMessage id="register.supplier" />}</p>
                        </div>
                        {/* {Object.keys(currentplan)?.length > 0 ?
                            <>
                                <div className="row">
                                    <div className='col-lg-7'>
                                        <div className="paybox dShow p-3 mb-5 bg-white">
                                            <div className="p_s">
                                                <div className="rightCon mb-3">
                                                    <div className="p_s_top mb-2 d-flex justify-content-between align-items-center">
                                                        <h4 className="font-16 Light_color fb mb-3">{currentplan && currentplan && currentplan.name}</h4>
                                                        {
                                                            currentplan && currentplan && currentplan.plan_payment_period === 1 ?
                                                                <p>{currency} {currentplan && currentplan && currentplan.monthly_price} <span>/ <FormattedMessage id="mo" /></span></p>
                                                                :
                                                                <p>{currency}{currentplan && currentplan && currentplan.yearly_price} <span>/ <FormattedMessage id="yr" /></span></p>
                                                        }

                                                    </div>
                                                    <div className="d-flex flex-wrap" style={{ gap: "8px 10px" }}>
                                                        <div className="device_d">
                                                            <span className="icon-device_1"></span>
                                                            <span className="icon-device_2"></span>
                                                            <p>{currentplan && currentplan && currentplan.device_limit + " " + deviceDisplay(currentplan.device_limit)} </p>
                                                        </div>
                                                        <div className="device_d">

                                                            {user?.role === 1 ? (
                                                                currentplan?.plan_id === JEWELER_SMALL_TEXT ? (
                                                                    <p>
                                                                        <i className="fas fa-search mr-1"></i>
                                                                        <FormattedMessage id="Searches_In_Month" defaultMessage="Searches_In_Month" />
                                                                    </p>
                                                                ) : (
                                                                    <p>
                                                                        <i className="fas fa-search mr-1"></i>
                                                                        {UNLIMITED_SEARCH}
                                                                    </p>
                                                                )
                                                            ) : (
                                                                <>
                                                                    <span className="fa fa-long-arrow-up"></span>
                                                                    <p>
                                                                        {currentplan?.upload_limit?.toLowerCase() === "unlimited" ? (
                                                                            localStorage.getItem('lang') === 'tr' ? ' Sınırsız' : 'Unlimited'
                                                                        ) : (
                                                                            <>
                                                                                {currency}
                                                                                {numberWithCommas(currentplan?.upload_limit)}
                                                                            </>
                                                                        )}
                                                                        &nbsp;
                                                                        {currentplan?.upload_limit &&
                                                                            currentplan?.upload_limit.toLowerCase() !== "unlimited upload" && (
                                                                                <FormattedMessage id="upload" defaultMessage="upload" />
                                                                            )}
                                                                    </p>
                                                                </>
                                                            )}




                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row choosers d-flex brdr-top pt-4 mt-2">
                                                <div className="col-md-5">
                                                    <p className="m-0"><FormattedMessage id="NextPayment" defaultMessage="Next Payment" />: <span> {currentplan &&  currentplan?.nextPaymentDate} </span></p>
                                                </div>
                                                <div className="col-md-7 text-right fb black-3B">
                                                    <div className="cus_switch m-0  d-flex align-item-center justify-content-end">
                                                        <p className="font-14 fr m-0  pl-3" style={{ color: "#236653", fontWeight: 600 }}><b
                                                            className="black-3B">{currentplan &&  currentplan.plan_payment_period == 1 ? <FormattedMessage id="Monthly" defaultMessage="Monthly" /> : <FormattedMessage id="Annual" defaultMessage="Annual" />}  </b> </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </> : null
                        } */}


                        {
                            user?.is_valid_plan == 1
                                ?
                                currentplan?.transaction_id &&
                                <Fragment>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-8">
                                            <div className="cu_head mb-3 d-flex justify-content-between align-items-center">
                                                <h2><FormattedMessage id="CurrentPlan" defaultMessage="Current Plan" /></h2>

                                                <div className="d-flex justify-content-between align-items-center" >


                                                    {user?.is_grace_period == 1 ? <button className='btn btn-black ml-3 px-3 py-2 font-14' style={{ lineHeight: 'normal', minWidth: 'auto', fontSize: '14px' }} onClick={handleRenewSubscription}>
                                                        <FormattedMessage id="renewPlan" defaultMessage="Renew" />
                                                    </button> : ""
                                                        // <h4 className="cancle_plan" onClick={handleCancelSubsClick}>
                                                        //     <span className="icon-close_1"></span>
                                                        //     &nbsp;<FormattedMessage id="CancelSubscription" defaultMessage="Cancel Subscription" />
                                                        // </h4>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-0 mb-5">
                                        <div className="col-lg-6 col-md-8 pl-0">

                                            {user?.is_grace_period == 1 ? <p className="font-14 fr mb-1" style={{ color: "#b43434", fontWeight: 600, lineHeight: 'normal' }}>
                                                <FormattedMessage id="gracePeriod" defaultMessage="You are currently in the grace period. Your plan will expire within the next 8 days. Please renew to avoid any disruption in service." />
                                            </p> : ''}


                                            <div className="paybox dShow p-3 ">
                                                <div className="p_s">
                                                    <div className="rightCon mb-3">
                                                        <div className="p_s_top mb-2 d-flex justify-content-between align-items-center">
                                                            <h4 className="font-16 Light_color fb mb-3">{currentplan && currentplan?.name}</h4>
                                                            {
                                                                currentplan && currentplan?.plan_payment_period === 1 ?
                                                                    <p>{currency} {currentplan && currentplan?.monthly_price} <span>/ <FormattedMessage id="mo" /></span></p>
                                                                    :
                                                                    <p>{currency}{currentplan && currentplan?.yearly_price} <span>/ <FormattedMessage id="yr" /></span></p>
                                                            }

                                                        </div>
                                                        <div className="d-flex">
                                                            <div className="device_d mr-3">
                                                                <span className="icon-device_1"></span>
                                                                <span className="icon-device_2"></span>
                                                                <p>{currentplan && currentplan?.device_limit + " " + deviceDisplay(currentplan?.device_limit)} </p>
                                                            </div>
                                                            <div className="device_d">

                                                                {user?.role === 1 ? (
                                                                    currentplan?.plan_id === JEWELER_SMALL_TEXT ? (
                                                                        <p>
                                                                            <i className="fas fa-search mr-1"></i>
                                                                            <FormattedMessage id="Searches_In_Month" defaultMessage="Searches_In_Month" />
                                                                        </p>
                                                                    ) : (
                                                                        <p>
                                                                            <i className="fas fa-search mr-1"></i>
                                                                            {UNLIMITED_SEARCH}
                                                                        </p>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        <span className="fa fa-long-arrow-up"></span>
                                                                        <p>
                                                                            {currentplan?.upload_limit?.toLowerCase() === "unlimited" ? (
                                                                                localStorage.getItem('lang') === 'tr' ? ' Sınırsız' : 'Unlimited'
                                                                            ) : (
                                                                                <>
                                                                                    {currency}
                                                                                    {numberWithCommas(currentplan?.upload_limit)}
                                                                                </>
                                                                            )}
                                                                            &nbsp;
                                                                            {currentplan?.upload_limit &&
                                                                                currentplan?.upload_limit.toLowerCase() !== "unlimited upload" && (
                                                                                    <FormattedMessage id="upload" defaultMessage="upload" />
                                                                                )}
                                                                        </p>
                                                                    </>
                                                                )}




                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row choosers d-flex brdr-top pt-4 mt-2">
                                                    <div className="col-md-5">
                                                        <p className="m-0"><FormattedMessage id="NextPayment" defaultMessage="Next Payment" />: <span> {currentplan && currentplan?.nextPaymentDate} </span></p>
                                                    </div>
                                                    <div className="col-md-7 text-right fb black-3B">
                                                        <div className="cus_switch m-0  d-flex align-item-center justify-content-end">
                                                            <p className="font-14 fr m-0  pl-3" style={{ color: "#236653", fontWeight: 600 }}><b
                                                                className="black-3B">{currentplan && currentplan?.plan_payment_period == 1 ? <FormattedMessage id="Monthly" defaultMessage="Monthly" /> : <FormattedMessage id="Annual" defaultMessage="Annual" />}  </b> </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                                :
                                // (currentplan?.profile?.plan_id || currentplan?.profile?.downgrade == 1)
                                (user?.plan_id && user?.role == 1) ? (
                                    <>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-8">
                                                <div className="cu_head mb-3 d-flex justify-content-between align-items-center">
                                                    <h2><FormattedMessage id="CurrentPlan" defaultMessage="Current Plan" /></h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mx-0 mb-5">
                                            <div className="col-lg-6 col-md-8 pl-0">
                                                <div className="paybox dShow p-3 ">
                                                    <div className="p_s">
                                                        <div className="rightCon mb-3">
                                                            <div className="p_s_top mb-2 d-flex justify-content-between align-items-center">
                                                                <h4 className="font-16 Light_color fb mb-3"><FormattedMessage id="Freemium" defaultMessage="Freemium" /></h4>

                                                            </div>


                                                            <p style={{ fontWeight: "bold", color: "red" }}> {
                                                                stringReplace(NEW_FREE_DOWNGRADE_FEATURE)
                                                            }</p>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </>

                                ) :
                                    currentplan?.OtherPlans?.map(plan => (
                                        plan?.user_type === PlanType?.Freemium ?
                                            <>
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-8">
                                                        <div className="cu_head mb-3 d-flex justify-content-between align-items-center">
                                                            <h2><FormattedMessage id="CurrentPlan" defaultMessage="Current Plan" /></h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mx-0 mb-5">
                                                    <div className="col-lg-6 col-md-8 pl-0">
                                                        <div className="paybox dShow p-3 ">
                                                            <div className="p_s">
                                                                <div className="rightCon mb-3">
                                                                    <div className="p_s_top mb-2 d-flex justify-content-between align-items-center">
                                                                        <h4 className="font-16 Light_color fb mb-3">{plan.name}</h4>
                                                                        {/* {
                                                                                                plan.plan_payment_period === 1 ?
                                                                                                    <p>{currency} {plan.monthly_price} <span>/ <FormattedMessage id="mo" /></span></p>
                                                                                                    :
                                                                                                    <p>{currency}{plan.yearly_price} <span>/ <FormattedMessage id="yr" /></span></p>
                                                                                            } */}
                                                                    </div>
                                                                    {/* <div className="d-flex">
                                                                                            <div className="device_d mr-3">
                                                                                                <span className="icon-device_1"></span>
                                                                                                <span className="icon-device_2"></span>
                                                                                                <p>{plan.device_limit + " " + deviceDisplay(plan?.device_limit)} </p>
                                                                                            </div>
                                                                                            <div className="device_d">
                                                                                                <span className="fa fa-long-arrow-up"></span>
                                                                                                <p>
                        
                                                                                                    {plan.upload_limit &&
                                                                                                        plan?.upload_limit.toLowerCase() === "unlimited" ?
                                                                                                        localStorage.getItem('lang') == 'tr' ? ' Sınırsız' : 'Unlimited'
                                                                                                        : `${currency}` + numberWithCommas(plan?.upload_limit)
                                                                                                    }
                                                                                                    &nbsp;
                                                                                                    {plan?.upload_limit &&
                                                                                                        plan?.upload_limit != "Unlimited upload" && <FormattedMessage id="upload" defaultMessage="upload" />}</p>
                                                                                            </div>
                                                                                        </div> */}

                                                                    <p style={{ fontWeight: "bold", color: "red" }}> {
                                                                        stringReplace(NEW_FREE_PLAN_FEATURE)
                                                                    }</p>

                                                                </div>
                                                            </div>
                                                            {/* <div className="row choosers d-flex brdr-top pt-4 mt-2">                                                            
                                                                                    <div className="col-md-7 text-right fb black-3B">
                                                                                        <div className="cus_switch m-0  d-flex align-item-center justify-content-end">
                                                                                            <p className="font-14 fr m-0  pl-3" style={{ color: "#236653", fontWeight: 600 }}><b
                                                                                                className="black-3B">{plan.plan_payment_period == 1 ? <FormattedMessage id="Monthly" defaultMessage="Monthly" /> : <FormattedMessage id="Annual" defaultMessage="Annual" />}  </b> </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            : ""
                                    ))
                        }
                        <form onSubmit={handleStripe}>
                            <div className='row'>
                                <div className='col-sm-6'>
                                    <h3 className="black-3B fb mb-4">
                                        <FormattedMessage
                                            id="billing.subscription-plan"
                                            defaultMessage="Subscription plan"
                                        />
                                    </h3>
                                </div>
                                <div className='col-sm-6'>
                                    <div className="cus_switch mb-3  d-flex align-item-center ms-auto justify-content-end">
                                        <p className="font-14 fr black-3B pr-3">
                                            <FormattedMessage
                                                id="billing.monthly"
                                                defaultMessage="Monthly"
                                            />
                                        </p>
                                        <label className="switch">
                                            <input type="checkbox" name="plan_payment_period" onChange={handlePlanPaymentPeriod} value={paymentInfo.plan_payment_period} />
                                            <span className="slider round"></span>
                                        </label>
                                        <p className="font-14 fr pl-3" style={{ color: "#236653", fontWeight: 600 }}><b
                                            className="black-3B">
                                            <FormattedMessage
                                                id="billing.annual"
                                                defaultMessage="Annual"
                                            />
                                        </b>
                                            <FormattedMessage
                                                id="billing.save-percentage"
                                                defaultMessage="Save up to 16.19%"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                {
                                    plan_role && plan_role && plan_role.map((plan) => {
                                        return (
                                            <a
                                                className={"col-lg-3 col-md-4 reg-plans pln-" + plan.id}
                                                onClick={() => selectPlan((paymentInfo?.plan_payment_period === 2 ? plan?.plan_id_year : plan?.plan_id_month), (plan?.name), (paymentInfo?.plan_payment_period === 2 ? plan?.yearly_price : plan?.monthly_price), plan.id)}
                                            >
                                                <div className={"py-4 justify-content-start h-100 sub_plan_box all-plan pln-box-" + plan.id}>
                                                    <input type='hidden' name='plan_name' value={plan.name} />
                                                    <h3 className={setColor(plan.order_by)}>{plan.name}</h3>

                                                    {
                                                        plan?.user_type == 0 ? <div className="device_d mb-3">{/* <p>{FREEMIUM_SEARCHES} <FormattedMessage id="Searches_A_Week" defaultMessage="Searches" /></p> */}
                                                            <p><i className="fas fa-search mr-1"></i><FormattedMessage id="Searches_A_Week" defaultMessage="Searches" /></p>

                                                        </div>
                                                            : plan?.trial == 1
                                                                ? <div className="device_d mb-3">
                                                                    <p><FormattedMessage id="CancelAnytime" defaultMessage="Cancel Anytime" /></p>
                                                                </div>
                                                                : plan?.id == JEWELER_SMALL_TEXT
                                                                    ? <div className="device_d mb-3">
                                                                        <p>
                                                                            <i className="fas fa-search mr-1"></i>
                                                                            <FormattedMessage id="Searches_In_Month" defaultMessage="Searches" />
                                                                        </p>

                                                                    </div>
                                                                    : plan?.user_type === 1 ? (
                                                                        <div className="device_d mb-3">
                                                                            <p>
                                                                                <i className="fas fa-search mr-1"></i>
                                                                                {UNLIMITED_SEARCH}
                                                                            </p>
                                                                        </div>
                                                                    ) : null
                                                    }


                                                    {plan.user_type == 2 &&
                                                        <div className="device_d mb-3"><span className="fa fa-long-arrow-up"></span><p>
                                                            {/* {plan.upload_limit == "Unlimited upload" ? */}
                                                            {plan.upload_limit && plan.upload_limit.toLowerCase() === "unlimited" ?
                                                                localStorage.getItem('lang') == 'tr' ? ' Sınırsız Yükleme' : 'Unlimited upload'
                                                                :
                                                                localStorage.getItem('lang') == 'tr' ? `${currency}` + (numberWithCommas(plan.upload_limit)) + ' Yükleme' : `${currency}` + (numberWithCommas(plan.upload_limit)) + ' upload'}

                                                        </p></div>
                                                    }

                                                    {plan.id == JEWELER_SMALL ?
                                                        <div className="device_d">
                                                            <p>{JEWELER_SMALL_SEARCHES} <FormattedMessage id="Searches" /></p>
                                                        </div>
                                                        :
                                                        <div className="device_d">
                                                            <span className="icon-device_1"></span>
                                                            <span className="icon-device_2"></span>
                                                            <p>{plan.device_limit + " " + deviceDisplay(plan.device_limit)} </p>
                                                        </div>
                                                    }
                                                    <p style={{ fontWeight: "bold", color: "red" }}>
                                                        {
                                                            plan.features !== null ?
                                                                stringReplace(plan?.features)
                                                                : ""
                                                        }
                                                    </p>

                                                    {
                                                        paymentInfo.plan_payment_period == 1 ?
                                                            <h4 className="monthly-price">{currency}{plan.monthly_price}/<FormattedMessage id="mo" /></h4> :
                                                            <h4 className="yearly-price">{currency}{plan.yearly_price}/<FormattedMessage id="yr" /></h4>
                                                    }
                                                    {plan.monthly_price > 0 &&
                                                        <p><span>Save {savePercentage(plan.monthly_price, plan.yearly_price) || "0.00"}%</span> <FormattedMessage id="billing.billed-yearly" /></p>
                                                    }
                                                </div>
                                                {/* </div> */}
                                            </a>
                                        )
                                    })
                                }
                            </div>

                            <div className="form-group login_btn d-flex align-items-center mt-4">
                                <button type="submit" className="btn-lg btn-black next-button">
                                    <FormattedMessage
                                        id="business.next"
                                        defaultMessage="Next"
                                    />
                                </button>

                            </div>
                        </form>
                    </div>
                    <ToastContainer
                        autoClose={2500}
                        hideProgressBar={true}
                        className="toast-chilling"
                        position="top-right"
                        newestOnTop={false}
                        closeOnClick={true}
                        rtl={false}
                        pauseOnFocusLoss={false}
                        draggable={false}
                        pauseOnHover={false}
                        theme="light"
                    />
                </div>

            </div>
        </Fragment>
    )
}

export default NewBillingInformation